import { Button, Dropdown, Input, Notification, Upload, toast } from "components/ui";
import { CompanyContext } from "contexts/CompanyContext";
import { ModalContext } from "contexts/ModalContext";
import React, { useContext, useEffect, useState, useTransition } from "react";
import { HiCheckCircle, HiOutlineMagnifyingGlass } from "react-icons/hi2";

import { useNavigate } from "react-router-dom";
import { getReadableByURL } from "utils/getReadableByURL";

import Masonry, { ResponsiveMasonry } from "react-responsive-masonry";
import { HiOutlineCheckCircle } from "react-icons/hi2";
import SocialNetworkSidePanel from "views/calendar/SocialNetworkSidePanel";
import { CalendarActiveSocialNetworkContext } from "contexts/CalendarActiveSocialNetworkContext";
import { socialNetworkPrompts, socialNetworkPromptsSuffix } from "components/layout/MagicEditor/functions/AdaptToSocialNetwork";
import { Loading } from "components/shared";
import { Trans, useTranslation } from "react-i18next";
import { getImageAICaptionURL } from "utils/getImageAICaption";
import capitalize from "components/ui/utils/capitalize";
import { AIContext } from "contexts/AIContext";
import ConfigPanel from "../ConfigPanel";
import ExploreMedia from "views/media/ExploreMedia";
import usePostGenerationQuantity from "utils/hooks/usePostGenerationQuantity";


const ImagesTemplate = ({
    generatePostsFromContexts,
    config,
    setConfig
}) => {

    const maxSelection = usePostGenerationQuantity();

    const [ selected, setSelected ] = useState([]);
    const { t } = useTranslation();

    const handleOnSubmit = async () => {
        const response = await Promise.allSettled(selected.map((item) => getImageAICaptionURL(item?.thumbnail)));
        const contexts = response.filter(e => !!e?.value).map(e => ({ source: { kind: 'image_description', content: e.value } }));
        const images = response.map((e, i) => !!e?.value ? selected[i]?.original : null).filter(e => !!e);
        generatePostsFromContexts(contexts, images);
    }

    const handleOnSelect = (originalSrc, asset) => {
        if (selected.length >= maxSelection) return false
        setSelected([...selected, { thumbnail: asset?.image?.thumbnail?.url || asset?.image?.url || originalSrc, original: originalSrc }]);
        return true;
    }

    const handleOnUnselect = (originalSrc, asset) => {
        setSelected(selected.filter(i => i.original != originalSrc));
        return true;
    }
    
    return (
        <div className="w-full h-full flex items-start p-4 gap-4">
            <ConfigPanel 
                selected={selected}
                onSubmit={handleOnSubmit}
                config={config}
                setConfig={setConfig}
                template="images"
            />
            <div className="flex-1 flex flex-col lg:flex-row gap-2 w-full h-full overflow-y-auto bg-secondary-500 dark:bg-gray-800 rounded-2xl">
                <div className="overflow-y-auto shrink-0 flex-1 p-4">
                    <div className='p-0 relative pb-4'> 
                        <ExploreMedia 
                            isSelectable={true} 
                            isMultipleSelect={true}
                            handleOnSelect={handleOnSelect} 
                            handleOnUnselect={handleOnUnselect} 
                            showMyAssets={true} 
                            allowedTypes={["image"]} 
                            breakpoints={{ 350: 1, 512: 2, 750: 2, 900: 3, 1100: 3, 1600: 3 } }
                        />
                    </div>
                </div>
            </div>
        </div>
    );
}

export default ImagesTemplate;